import React from "react"
import { Overlay, PopupContainer, ImageSection, ContentSection, CloseButton, PopupTitle, PopupText, PopupButton } from "./Style"

const Popup = ({ title, text, buttonLabel, onClick, onClose, imageUrl }) => {
  return (
    <>
      <Overlay onClick={onClose} />
      <PopupContainer>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <ImageSection imageUrl={imageUrl} />
        <ContentSection>
          <PopupTitle>{title}</PopupTitle>
          <PopupText>{text}</PopupText>
          <PopupButton onClick={onClick}>{buttonLabel}</PopupButton>
        </ContentSection>
      </PopupContainer>
    </>
  )
}

export default Popup
